const getCheckedValuesFromObject = ob => Object.entries(ob)
  .filter(([_, value]) => value)
  .map(([id]) => id);

export default getCheckedValuesFromObject;
